var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('invoice-table',{attrs:{"api":_vm.api,"more-params":_vm.moreParams}})}
var staticRenderFns = []

export { render, staticRenderFns }